import { template as template_7b520a51f6ac4b0d8ee0ac011dbfc413 } from "@ember/template-compiler";
import { service } from '@ember/service';
import BalanceBanner from 'client-portal/components/site/billing/balance-banner';
import BillingAndPaymentsTabs from 'client-portal/components/site/billing/billing-and-payments-tabs';
import BillingPage from 'client-portal/components/site/billing-page';
import Component from '@glimmer/component';
import Container from 'client-portal/components/layout/container';
import ExternalBillingBanner from 'client-portal/components/site/billing/external-billing-banner';
import PageTitle from 'client-portal/components/site/page-title';
import TransferSetupBanner from 'client-portal/components/site/billing/transfer-setup-banner';
import t from 'ember-intl/helpers/t';
const EXTERNAL_BILLING_BANNER_KEY_SEGMENTS = [
    'header',
    'body',
    'ctaLink',
    'cta'
];
export default class SiteBillingBillingAndPaymentsTab extends Component {
    @service
    billingTransfer;
    @service
    intl;
    get showExternalBillingBanner() {
        return (this.args.client?.latestChannelHasBillingBannerEnabled && this.isChannelEnrollmentCompleted && !this.billingTransfer.isPendingTransfer);
    }
    get isChannelEnrollmentCompleted() {
        let channelName = this.args.client?.latestChannelName;
        let enrollment = this.args.client?.monarchChannelClientInfos?.find((info)=>info.globalMonarchChannel?.name === channelName);
        return enrollment?.enrollmentStatus === 'completed';
    }
    get channelBannerText() {
        let channelName = this.args.client?.latestChannelName;
        let bannerText = {};
        let missingKeys = [];
        EXTERNAL_BILLING_BANNER_KEY_SEGMENTS.forEach((segment)=>{
            let key = `channel-specific.${channelName}.externalBillingBanner.${segment}`;
            if (this.intl.exists(key)) {
                bannerText[segment] = this.intl.t(key);
            } else {
                missingKeys.push(segment);
            }
        });
        if (missingKeys.length > 0) {
            // eslint-disable-next-line no-console
            console.error(`Missing translations for external billing banner sections (channel: ${channelName}):`, missingKeys);
            return null;
        }
        return bannerText;
    }
    get hasOutstandingNonChannelInvoices() {
        return this.args.client?.visibleUnpaidInvoices?.some((invoice)=>invoice.remainingAmount > 0);
    }
    get showBannerOnly() {
        return (this.showExternalBillingBanner && this.channelBannerText && !this.hasOutstandingNonChannelInvoices && !(this.args.client?.visibleBalanceDue < 0));
    }
    static{
        template_7b520a51f6ac4b0d8ee0ac011dbfc413(`
    <BillingPage>
      <PageTitle @title={{t "billing.pageTitle"}} />
      <Container>
        <TransferSetupBanner />
        {{#if this.showExternalBillingBanner}}
          {{#let this.channelBannerText as |bannerText|}}
            {{#if bannerText}}
              <ExternalBillingBanner @bannerText={{bannerText}} />
            {{/if}}
          {{/let}}
        {{/if}}
        {{#unless this.showBannerOnly}}
          <BalanceBanner @client={{@client}} />
          <BillingAndPaymentsTabs />
          {{yield}}
        {{/unless}}
      </Container>
    </BillingPage>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
